import { Scrollbars } from 'react-custom-scrollbars';
import React, { Component } from 'react';

export default class AddEditUserScrollbars extends Component {

    state = {
        scrollbarsHeight: this.props.height,
        displayScrolls: false
    }
    
    shouldDisplayScrollsbar = () => {

        return window.innerHeight < 800 ? true : false;
    }

    calcScrollbarsHeight = () => {

        const result = this.shouldDisplayScrollsbar();
        
        this.setState({
            scrollbarsHeight: result ? '' : this.props.height,
            displayScrolls: result
        });
    }

    viewPortChanged = () => {

        window.addEventListener('resize', this.calcScrollbarsHeight);
    }

    componentDidMount() {

        this.calcScrollbarsHeight();
    }

    componentWillUnmount() {

        window.removeEventListener('resize', this.calcScrollbarsHeight, false);
    }
   
    render() {

        this.viewPortChanged();

        return (
            <Scrollbars 
                autoHeight={this.state.displayScrolls}
                style={{
                    height: this.state.scrollbarsHeight
                }}
                {...this.props}
            >
                <div
                    style={{
                        width: '98%'
                    }}
                >
                    {
                        this.props.children
                    }
                </div>
            </Scrollbars>
        );
    }
}